/**
 * Wrapper around fetch that automatically adds the Cognito JWT token
 * to the Authorization header for authenticated requests.
 */
export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const { ...fetchOptions } = options;

  try {
    const { fetchAuthSession } = await import("aws-amplify/auth");
    const session = await fetchAuthSession();
    // Use the ID token for API authentication: Cognito ID tokens carry the `aud`
    // claim set to the user pool client ID, which the backend validates via
    // ValidAudience. Access tokens use `aud: "empty"` in Cognito, causing a
    // 401 "The audience 'empty' is invalid" error on every authenticated request.
    const idToken = session.tokens?.idToken?.toString();

    if (idToken) {
      fetchOptions.headers = {
        ...fetchOptions.headers,
        Authorization: `Bearer ${idToken}`,
      };
    }
  } catch {
    // No valid session, proceed without token
    // The API will return 401 if authentication is required
  }

  return fetch(url, fetchOptions);
}
